import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

import {
  RuleManagementOverviewComponent,
} from '../../ruleManagement/overview/rule-management-overview.component';
import {MyChecksOverviewComponent} from '../my-checks-overview/my-checks-overview.component';
import {MyCheckTab, parseMyCheckTab} from '../shared/my-check-tabs/my-check-tabs.component';
import {
  CheckRunSchedulesOverviewComponent,
} from '../check-run-schedules/check-run-schedules-overview.component';

/**
 * Hülle der myCheck-Ansicht mit den Tabs Eigene, Prüfläufe, BIC Katalog und Zeitpläne.
 *
 * <p>Der aktive Tab steckt im Query-Parameter statt in einem eigenen Pfad, damit Lesezeichen auf
 * `my-checks` weiter funktionieren. `data.defaultTab` lässt Alt-Routen wie `check-runs` denselben
 * Bereich mit anderem Start-Tab öffnen, ohne Redirect.
 */
@Component({
  selector: 'app-my-check-hub',
  standalone: true,
  imports: [RuleManagementOverviewComponent, MyChecksOverviewComponent, CheckRunSchedulesOverviewComponent],
  template: `
    @switch (tab) {
      @case ('runs') {
        <my-checks-overview class="block h-full" mode="own"></my-checks-overview>
      }
      @case ('catalog') {
        <my-checks-overview class="block h-full" mode="catalog"></my-checks-overview>
      }
      @case ('schedules') {
        <app-check-run-schedules-overview class="block h-full"></app-check-run-schedules-overview>
      }
      @default {
        <app-rule-management-overview class="block h-full"></app-rule-management-overview>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [':host { display: block; height: 100%; }'],
})
export class MyCheckHubComponent implements OnInit, OnDestroy {
  protected tab: MyCheckTab = 'own';

  private route = inject(ActivatedRoute);
  private querySubscription?: Subscription;

  ngOnInit(): void {
    const fallback = parseMyCheckTab(this.route.snapshot.data['defaultTab']);
    // queryParamMap statt Snapshot: der Tabwechsel bleibt auf derselben Route.
    this.querySubscription = this.route.queryParamMap.subscribe(params => {
      this.tab = parseMyCheckTab(params.get('tab'), fallback);
    });
  }

  ngOnDestroy(): void {
    this.querySubscription?.unsubscribe();
  }
}
